import ElCollapseItem from '../collapse/src/collapse-item.vue'

/* istanbul ignore next */
ElCollapseItem.install = function (app) {
  app.component(ElCollapseItem.name, ElCollapseItem)
}

export default ElCollapseItem
